import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { underscore } from '@ember/string';

interface AditoolsToolbarActionSignature {
  Element: HTMLButtonElement;
  Args: {
    label: string;
    iconClass: string;
    qaName?: string;
    onOpen?: () => void;
    onSubmit?: () => void;
    onClose?: () => void;
  };
  Blocks: {
    default: [() => void, () => void];
  };
}
export default class AditoolsToolbarAction extends Component<AditoolsToolbarActionSignature> {
  @tracked isActive = false;

  get qaName() {
    return this.args.qaName || underscore(this.args.label.toLowerCase());
  }

  @action activate() {
    this.isActive = true;
    if (this.args.onOpen) {
      this.args.onOpen();
    }
  }
  @action select() {
    this.isActive = false;
    if (this.args.onSubmit) {
      this.args.onSubmit();
    }
  }
  @action close() {
    this.isActive = false;
    if (this.args.onClose) {
      this.args.onClose();
    }
  }
}
